//import { AmazonConnectProvider } from 'contexts/AmazonConnectContext';
import { SessionModal } from 'components/app/SessionModal';
import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import 'semantic-ui-css/semantic.css';
import { AppRouter } from 'routes/root';

import { AppProvider } from './contexts/AppContext';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <AppProvider>
    {/* <AmazonConnectProvider> */}
      <div id="root" className="topbar">
        <AppRouter />
      </div>
    {/* </AmazonConnectProvider> */}
    <SessionModal />
  </AppProvider>,
  document.querySelector('#root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
